import * as React from "react"
const SvgGift = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.83 7.429H20q.824 0 1.413.587.587.588.587 1.413v2q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588v7q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.587H6q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20.428v-7q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 11.429v-2q0-.825.587-1.413A1.93 1.93 0 0 1 4 7.429h2.17a3 3 0 1 1 5.83-1 3 3 0 1 1 5.83 1m-9.83-1a1 1 0 0 0 1 1h1v-1a1 1 0 1 0-2 0m6 1h1a1 1 0 1 0-1-1zm-10 2v2h7v-2zm7 11v-7H6v7zm2 0h5v-7h-5zm7-9v-2h-7v2z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgGift
